
import { Button, ControlList, Dialog, Dropdown, IconButton, Menu, MenuItemProps, useGraphqlDelete, useGraphqlMutation, useTranslations, useUrlParamsValue } from "@bsm/component";
import { useAppointmentDetailsMenu } from "../hooks/useAppointmentDetailsMenu"
import { useCallback, useMemo, useState } from "react";
import moment from "moment";
import { AppointmentDetailsToolboxProps } from "./AppointmentDetailsToolbox";
import { useTimeOffQuery } from "../../../../../hooks/useTimeOffQuery";

export const AppointmentDetailsMenu = (props: AppointmentDetailsToolboxProps) => {

    const [
        DELETE_CONFIRM,
        DELETE_ONE_LABEL,
        DELETE_ALL_LABEL,
        EDIT_CONFIRM,
        CONFIRMATION_TITLE,
        CANCEL_BTN,
        OK_BTN,
    ] = useTranslations(i18n);

    const [open, setOpen] = useState<boolean>();
    // const items = useAppointmentDetailsMenu(props.id)
    // const [anchor, setAnchor] = useState<HTMLButtonElement>()
    const { data } = useTimeOffQuery(props.id, true);

    const deleteMutation = useGraphqlDelete("timeoff");

    const handleDeleteAllConfirmed = () => {
        deleteMutation.mutate(
            { ids: [props.id] },
            {
                onSuccess: (data) => {
                    setOpen(false);
                    props.onDeleted?.()
                },
            }
        );
    };

    // const handleMenuClick = useCallback(async (menu: MenuItemProps) => {
    //     if (menu.ke === 'delete') {
    //         setOpen(true)
    //     }
    // }, [])


    const handleCloseDialog = () => {
        setOpen(false);
    };

    return (
        <>
            {data.isDeletable && (
                <div className="flex gap-2">
                    <IconButton
                        className="ml-auto mr-2 text-danger"
                        icon="fa-solid fa-trash-can"
                        onClick={(e) => setOpen(true)}
                    />
                </div>
            )}

            {/* <Dropdown anchorEl={anchor} onClose={() => setAnchor(undefined)}>
                <Menu
                    onClick={handleMenuClick}
                    items={items}
                />
            </Dropdown> */}

            <Dialog
                open={open}
                onClose={handleCloseDialog}
                btnOk={{
                    className: "btn-danger",
                    label: OK_BTN,
                    isSubmit: deleteMutation.isLoading,
                }}
                btnCancel={{ label: CANCEL_BTN }}
                title={CONFIRMATION_TITLE}
                onCancel={handleCloseDialog}
                onConfirm={handleDeleteAllConfirmed}
            >
                <span>{DELETE_CONFIRM}</span>
            </Dialog>

        </>
    )
}

const i18n = [
    "BSMRH.DayOff.Leaving.Delete.Confirm.Message",
    "Harea.Calendar.Edit.DeleteOne.Button.Label",
    "Harea.Calendar.Edit.DeleteAll.Button.Label",
    "Harea.Vacation.Edit.Repetition.Confirm.Message",
    "std_confirmation",
    "std_cancel",
    "std_confirm",
];
